/* eslint-disable  @typescript-eslint/no-explicit-any */
import { postWithAuth } from '@/api/httpRequests'
import { epgEndpoint } from '@/api/apiConstants'
import { epgChannelRequest } from '@/types/epg/epgChannelRequest'
import {
    // PRESENT_FOLLOWING_ACTUAL_DATE_CORRECTION,
    PRESENT_FOLLOWING_DATE_CORRECTION,
    // PRESENT_FOLLOWING_PROGRAMS_COUNT,
    presentFollowingDuration,
    presentFollowingId,
} from '@/shared/constants'
// import Channel from '../../channels/channel'

export const getMissingPrograms = async (
    list?: epgChannelRequest[],
    isPresentFollowing?: boolean
) => {
    if (!list && !isPresentFollowing) return
    const defaultStartEpochSecs = Math.ceil(Date.now() / 1000) // Date.now() / 1000 i zaokrąglić
    const stringifiedChannels = isPresentFollowing
        ? JSON.stringify({
              channelIds: presentFollowingId,
              date: defaultStartEpochSecs,
              duration: presentFollowingDuration,
          })
        : JSON.stringify(list)

    const programsResponse = await postWithAuth(
        epgEndpoint,
        true,
        stringifiedChannels
    )
    return programsResponse
}

// const getProgramsForChannelBatch = async (channelBatch: Channel[]) => {
//     const defaultStartEpochSecs =
//         Math.ceil(Date.now() / 1000) - PRESENT_FOLLOWING_ACTUAL_DATE_CORRECTION
//
//     const stringifiedChannels = JSON.stringify(
//         channelBatch.map((channel) => ({
//             channelId: channel.id,
//             start: defaultStartEpochSecs,
//             count: PRESENT_FOLLOWING_PROGRAMS_COUNT,
//         }))
//     )
//
//     const programsResponse = await postWithAuth(
//         epgEndpoint,
//         true,
//         stringifiedChannels
//     )
//
//     return programsResponse
// }

export const getProgramsForAllChannels = async (): Promise<any> => {
    const defaultStartEpochSecs = Math.ceil(Date.now() / 1000) // Date.now() / 1000 i zaokrąglić
    const stringifiedChannels = JSON.stringify({
        channelIds: 'all',
        date: defaultStartEpochSecs - PRESENT_FOLLOWING_DATE_CORRECTION,
        count: 10,
    })

    return await postWithAuth(epgEndpoint, true, stringifiedChannels)
}

// export const getProgramsForAllChannels = async (
//     channels: Channel[]
// ): Promise<any> => {
//     if (!channels || !channels.length) return
//
//     const batchSize = 30
//     const channelBatches = []
//
//     for (let i = 0; i < channels.length; i += batchSize) {
//         const batch = channels.slice(i, i + batchSize)
//         channelBatches.push(batch)
//     }
//
//     const programsByBatch = await Promise.all(
//         channelBatches.map((batch) => getProgramsForChannelBatch(batch))
//     )
//
//     return programsByBatch.flat()
// }
